import React from 'react'
import { Modal, Button, Icon } from 'antd'
import './RegenerationInfoModal.scss'

const RegenerationInfoModal = ({ visible, onClose, affectedScenes }) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable={false}
      width={520}
      className="shl-regeneration-info-modal"
    >
      <div className="shl-regeneration-info-modal__content">
        <div className="shl-regeneration-info-modal__icon-wrapper">
          <div className="shl-regeneration-info-modal__icon-bg">
            <Icon
              type="info-circle"
              className="shl-regeneration-info-modal__icon"
            />
          </div>
        </div>

        <h2 className="shl-regeneration-info-modal__title">Updating Videos</h2>

        <div className="shl-regeneration-info-modal__description">
          <p>
            We are regenerating videos for some scenes to keep them perfectly
            synced with your latest changes.
          </p>

          <div className="shl-regeneration-info-modal__scene-list">
            <small>Affected Scenes:</small>
            <ul>
              {affectedScenes.map((scene, index) => (
                <li key={index}>{scene}</li>
              ))}
            </ul>
          </div>

          <p className="shl-regeneration-info-modal__reason">
            This is happening because the shot structure was modified (added or
            deleted shots), and we need to recalculate video durations to match
            the voiceover timing.
          </p>
        </div>

        <div className="shl-regeneration-info-modal__actions">
          <Button
            className="shl-regeneration-info-modal__btn shl-regeneration-info-modal__btn--confirm shl-primary-btn"
            onClick={onClose}
            type="primary"
            size="large"
            shape="round"
          >
            Got it
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default RegenerationInfoModal
